export default __webpack_public_path__ + "static/media/logo new.b945c56b.jpg";